// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"f63176b2","198":"fb725107","445":"835e436c","453":"3c1cfbe1","470":"09ec5461","835":"473faefd"}[chunkId] + ".chunk.js";
};